import dayjs, { Dayjs } from 'dayjs';

import { ICommitteeApprovalDateFormValues } from './ReviewSummaryReportFormProvider/types';
import { ICommitteeApprovalDate } from '@Domains/ReviewSummaryReport';

export const checkValidOperatingYear = (operatingYear?: number): boolean => {
  if (!operatingYear) return false;

  const currentYear = new Date().getFullYear();
  return operatingYear === currentYear || operatingYear === currentYear - 1;
};

const setTimeUtc = (date: Dayjs) => {
  return dayjs(date).set('hour', 7);
};

export const mapCommitteeApprovalDateToPayload = (
  formValues: ICommitteeApprovalDateFormValues
): ICommitteeApprovalDate => {
  const { committeeApprovalDate } = formValues;

  return {
    committeeApprovalDate: committeeApprovalDate
      ? setTimeUtc(committeeApprovalDate).toDate()
      : null,
  } as ICommitteeApprovalDate;
};

export const mapCommitteeApprovalDateToFromValues = (
  data: ICommitteeApprovalDate
): ICommitteeApprovalDateFormValues => {
  const { committeeApprovalDate } = data || {};

  return {
    committeeApprovalDate: committeeApprovalDate
      ? dayjs(committeeApprovalDate)
      : undefined,
  } as ICommitteeApprovalDateFormValues;
};
